import { createSlice } from '@reduxjs/toolkit';
import { HandlersActionResponse } from '../athenaApiGen';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../utils/tableVariables';

type TFinancialPlansInitialState = {
  isCreateOpenModal: boolean;
  isEditModalOpen: boolean;
  page: number;
  pageSize: number;
  selectedPlanId: string | null;
  allowedActions: HandlersActionResponse[];
};

const initialState: TFinancialPlansInitialState = {
  isCreateOpenModal: false,
  isEditModalOpen: false,
  selectedPlanId: null,
  page: 0,
  pageSize: DEFAULT_TABLE_PAGE_SIZE,
  allowedActions: [],
};

const financialPlansSlice = createSlice({
  name: 'financialPlans',
  initialState,
  reducers: {
    setCreateModal: (state, action) => {
      state.isCreateOpenModal = action.payload;
    },
    setEditModalOpen: (state, action) => {
      state.isEditModalOpen = action.payload;
    },
    setPlanId: (state, action) => {
      state.selectedPlanId = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setAllowedActions: (state, action) => {
      state.allowedActions = action.payload;
    },
  },
});

const {
  setCreateModal,
  setEditModalOpen,
  setPage,
  setPageSize,
  setAllowedActions,
  setPlanId,
} = financialPlansSlice.actions;

export {
  setAllowedActions,
  setCreateModal,
  setEditModalOpen,
  setPage,
  setPageSize,
  setPlanId,
};

export default financialPlansSlice.reducer;
